import { http } from "@/communication";
import moment from "moment";

export const moderationModule = {
  namespaced: true,
  state: {
    customer: null,
    dialog: null,
    dialogNotes: {},
    dialogInfoMessages: [],
    fake: null,
    firstContact: null,
    friendship: null,
    stats: {},
    isAsa: false,
    working: true
  },
  actions: {
    newDialog({ commit }) {
      commit("setWorking", true);
      return http.get("/api/v2/moderation/").then(({ data }) => {
        commit("setCustomerAndFake", data);
        commit("setWorking", false);
      });
    },
    loadFakeByName({ commit }, name) {
      return http
        .get("/api/v1/customerProfile/", {
          params: {
            filter: [{ name: "fake" }, { name: "where", attributes: { name } }]
          }
        })
        .then(({ data }) => {
          if (!Array.isArray(data)) {
            commit("setFake", data);
          } else {
            commit("setFake", null);
          }
        });
    }
  },
  mutations: {
    setCustomerAndFake(
      state,
      {
        dialog,
        customer,
        fake,
        friend_status,
        stats,
        dialogNotes,
        first_contact,
        dialogInfoMessages,
        profileVisits
      }
    ) {
      moment.locale("de");
      state.fake = fake;
      state.dialog = dialog;
      state.customer = customer;
      state.friendship = friend_status;
      state.stats = stats;
      state.dialogNotes = dialogNotes;
      state.firstContact = first_contact;
      state.dialogInfoMessages = dialogInfoMessages;
      state.fake.last_visit = profileVisits.fake
        ? moment(profileVisits.fake.visited_at).fromNow()
        : "-";
      state.customer.last_visit = profileVisits.customer
        ? moment(profileVisits.customer.visited_at).fromNow()
        : "-";
    },
    setWorking(state, working) {
      state.working = working;
    },
    setFriendship(state, friend_status) {
      state.friendship = friend_status;
    },
    newTransaction(state, transaction) {
      if (state.customer) {
        state.customer.balance = parseInt(transaction.total);
      }
    },
    setFake(state, fake) {
      state.fake = fake;
    }
  },
  getters: {
    fake({ fake }) {
      return fake;
    },
    customer({ customer }) {
      return customer;
    },
    dialogInfoMessages({ dialogInfoMessages }) {
      return dialogInfoMessages;
    },
    dialogNotes({ dialogNotes }) {
      return dialogNotes;
    },
    firstContact({ firstContact }) {
      return firstContact;
    },
    friendship({ friendship }) {
      return friendship;
    },
    stats({ stats }) {
      return stats;
    },
    working({ working }) {
      return working;
    },
    dialog({ dialog }) {
      return dialog;
    },
    isAsa({ dialog }) {
      return dialog && dialog.type === 2;
    }
  }
};
